import { render, staticRenderFns } from "./ProductsListSimple.vue?vue&type=template&id=60e53536"
import script from "./ProductsListSimple.vue?vue&type=script&lang=js"
export * from "./ProductsListSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports